<template>
	<div class="sf-card__content">
		<el-row :gutter="20">
			<el-col :span="8">
				<sf-input-group
					:label="getMessage_('MWCC000104')"
					:labelSpan="10"
					labelPosition="left"
					:onChange="value => onChange({ key: 'permGrpCd', value })"
					:inputValue="selectedRow.permGrpCd"
					readonly
				/>
			</el-col>
			<el-col :span="8">
				<sf-input-group
					:label="getMessage_('MWCC000105')"
					:labelSpan="10"
					labelPosition="left"
					:onChange="value => onChange({ key: 'userGrpName', value })"
					:inputValue="selectedRow.userGrpName"
				/>
			</el-col>
			<el-col :span="8">
				<sf-select-group
					:label="getMessage_('MWCC000106')"
					:labelSpan="10"
					labelPosition="left"
					:onChange="value => onChange({ key: 'useYn', value })"
					:options="gridUseYnList_"
					:inputValue="selectedRow.useYn"
				/>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/GridFreeForm/store/helpers';
export default {
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		onChange({ key, value }) {
			this.setSelectedRow_({ key, value });
		}
	}
};
</script>

<style></style>
